import { render, staticRenderFns } from "./CampaignCategoriesPage.vue?vue&type=template&id=c05803c2&"
import script from "./CampaignCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./CampaignCategoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c05803c2')) {
      api.createRecord('c05803c2', component.options)
    } else {
      api.reload('c05803c2', component.options)
    }
    module.hot.accept("./CampaignCategoriesPage.vue?vue&type=template&id=c05803c2&", function () {
      api.rerender('c05803c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CampaignCategoriesPage.vue"
export default component.exports